import api from 'helpers/api';
import API_ENDPOINT from 'constants/apiEndpoint';
import { TApiResult } from 'types/common';

type TLoginResult = {
  accessToken: string;
  /** The session's other half. Previously dropped on the floor, which is why sessions died at the
   *  access token's lifetime with no way to renew. */
  refreshToken: string;
  email?: string;
};

export const login = (email: string, password: string): Promise<TLoginResult> =>
  api
    .post<TApiResult<TLoginResult>>(API_ENDPOINT.auth.login, {
      email,
      password,
      loginChannel: 'BUSINESS_ADMIN_PANEL',
    })
    .then((r) => r.result);
